(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discovery-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sectionWrapper = document.querySelector('.shopify-section.discovery-banner');

    if (sectionWrapper) {
      sectionWrapper.setAttribute('role', 'region');
      sectionWrapper.setAttribute('aria-label', 'Discovery Banner'); 
    } else {
      console.warn('Could not find the banner section wrapper to add accessibility attributes.');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
